import _ from 'lodash';

const patternYoutubeURLs = ['youtube.com/watch?v=', 'youtu.be/', 'www.youtube.com/embed/'];

const patternFacebookURLs = ['fb.watch/', 'videos/', 'videos%'];

const isYoutubeURL = (url) => {
  if (url) {
    return _.some(patternYoutubeURLs, (patternYoutubeURL) => {
      return url.includes(patternYoutubeURL);
    });
  }
  return false;
};

const isValidURL = (patternURLs, url) => {
  if (url) {
    return _.some(patternURLs, (patternURL) => {
      return url.includes(patternURL);
    });
  }
  return false;
};


const parseYoutubeURLToEmbed = (url) => {
  let youtubeEmbed;
  if (url) {
    _.forEach(patternYoutubeURLs, (patternYoutubeURL) => {
      if (url.includes(patternYoutubeURL)) {
        const array = url.split(patternYoutubeURL);
        const youtubeKey = array[array.length - 1];
        youtubeEmbed = `https://www.youtube.com/embed/${youtubeKey}`;
      }
    });
    return youtubeEmbed;
  }
  return url;
};


const getAttributeSrcFromString = (htmlString) => {
  const tmp = document.createElement('div');
  tmp.innerHTML = htmlString.trim();
  const div = tmp.firstChild;
  return div.src;
};

const parerSourceURLFromURL = (url) => {
  if (url && url.includes('<')) {
    if (getAttributeSrcFromString(url)) {
      return getAttributeSrcFromString(url);
    }
  }
  return url;
};

const parseURLToEmbedURL = (url) => {
  const sourceURL = parerSourceURLFromURL(url);
  if (isYoutubeURL(sourceURL)) {
    return parseYoutubeURLToEmbed(sourceURL);
  }
  return url;
};


const splitStingByPatternURL = (url, patternURL) => {
  const array = url.split(patternURL);
  const params = array[array.length - 1];
  // clean sourceKey when url has another params e.g. youtube.com/watch?v=xxxxx&channel=byteark;
  if (params.includes('&')) {
    const arrayParams = params.split('&');
    return arrayParams[0];
  }
  return params;
};

const getSourceKeyByType = (patternURLs, url) => {
  let sourceKey;
  if (url) {
    _.forEach(patternURLs, (patternURL) => {
      if (url.includes(patternURL)) {
        sourceKey = splitStingByPatternURL(url, patternURL);
      }
    });
    return sourceKey;
  }
  return url;
};

const parseURLToSourceKeyByType = (type, url) => {
  const sourceURL = parerSourceURLFromURL(url);
  switch (type) {
    case 'byteark':
      return sourceURL;
    case 'facebook':
      return getSourceKeyByType(patternFacebookURLs, sourceURL);
    case 'youtube':
      return getSourceKeyByType(patternYoutubeURLs, sourceURL);
    default:
      return sourceURL;
  }
};

const isValidEmbedURL = () => {};

const isValidEmbedUrlByType = (type, url) => {
  const sourceURL = parerSourceURLFromURL(url);
  switch (type) {
    case 'byteark':
      return sourceURL.includes('.m3u8');
    case 'facebook':
      return isValidURL(patternFacebookURLs, sourceURL);
    case 'youtube':
      return isValidURL(patternYoutubeURLs, sourceURL);
    default:
      return sourceURL.includes('.m3u8');
  }
};

export {
  isValidEmbedURL,
  parseURLToEmbedURL,
  parseURLToSourceKeyByType,
  isValidEmbedUrlByType,
};
